import {useEffect, useMemo} from 'react';

import {isInaccessible} from 'graphql-client/InaccessibleInfo';
import {Worksheet} from 'notebook/worksheets/WorksheetConstants';
import {
  PMEIsQuery_procedureMethodExecutionInstances as PMEIorInaccessible,
  PMEIsQuery_procedureMethodExecutionInstances_ProcedureMethodExecutionInstanceNode as PMEI,
} from 'procedures/worksheets/__generated/PMEIsQuery';

// The following is a store that helps gather client state about PMEIs and their documents. This is a stop-gap
// solution since we need the PMEIs to do resolution. This store and it's usages should be removed once we
// have better loading indicators in resolution TODO(BNCH-121087)

const PMEIsByDocumentsStore: Record<string, Set<string>> = {};

export function getPMEIsForDocument(documentId: string): Set<string> | undefined {
  return PMEIsByDocumentsStore[documentId];
}

export function useSetProcedurePMEIDocumentStoreFromWorksheet(
  worksheet: Worksheet,
  pmeis: Array<PMEIorInaccessible>
): void {
  const documentIds = useMemo(
    () =>
      worksheet.worksheetStepGroups.flatMap((stepGroup) =>
        stepGroup.worksheetSteps.map((step) => step.document.id)
      ),
    [worksheet]
  );
  const pmeiIds = useMemo(
    () => new Set(pmeis.filter((pmei): pmei is PMEI => !isInaccessible(pmei)).map((pmei) => pmei.id)),
    [pmeis]
  );
  useEffect(() => {
    // Add the PMEI ids to the Store for each document id
    for (const documentId of documentIds) {
      PMEIsByDocumentsStore[documentId] = pmeiIds;
    }
    // Clean up the Store on unmount
    return () => {
      for (const documentId of documentIds) {
        delete PMEIsByDocumentsStore[documentId];
      }
    };
  }, [pmeiIds, documentIds]);
}
